/* LES ANCRES DU JOURNAL — 07/09/2026
 *
 * « Le sommaire n'est pas cliquable. »  Il ne pouvait pas l'etre :
 * les titres des articles n'ont aucun identifiant, et le corps d'un
 * article Shopify est du HTML libre. Plutot que d'aller poser des id
 * a la main dans vingt articles -- et de devoir y penser a chaque
 * nouvel article -- on les pose ici, au chargement.
 *
 * Le script fait trois choses, et rien d'autre :
 *   1. il donne un identifiant a chaque titre de section (h2) ;
 *   2. il transforme les lignes du sommaire en liens vers ces titres,
 *      en appariant par le texte ;
 *   3. il decale le defilement de la hauteur de l'en-tete collant,
 *      sans quoi le titre vise se retrouve cache dessous.
 *
 * Si un article n'a pas de sommaire, le script pose quand meme les
 * identifiants : une adresse du type /blogs/journal/x#ma-section
 * fonctionne alors, ce qui sert pour un lien envoye par message.
 */
(function () {
  'use strict';

  // Un titre en identifiant : sans accents, sans ponctuation, en
  // minuscules, les espaces devenant des traits d'union.
  function enIdentifiant(texte) {
    return texte
      .normalize('NFD')
      .replace(/[̀-ͯ]/g, '')
      .toLowerCase()
      .replace(/['’]/g, '-')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '')
      .slice(0, 60);
  }

  // Pour l'appariement sommaire <-> titre : on compare des formes
  // reduites, car le sommaire reprend rarement le titre au mot pres.
  function reduire(texte) {
    return texte
      .normalize('NFD')
      .replace(/[̀-ͯ]/g, '')
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, ' ')
      .trim();
  }

  function hauteurEntete() {
    var e = document.querySelector('.section-header, .header-wrapper, .header');
    if (!e) return 24;
    var pos = window.getComputedStyle(e).position;
    // Un en-tete qui defile avec la page ne masque rien.
    if (pos !== 'sticky' && pos !== 'fixed') return 24;
    return Math.round(e.getBoundingClientRect().height) + 20;
  }

  function allerA(cible) {
    var y = cible.getBoundingClientRect().top + window.pageYOffset - hauteurEntete();
    var doux = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.scrollTo({ top: y, behavior: doux ? 'smooth' : 'auto' });
  }

  function poser() {
    var corps = document.querySelector('.article-template__content');
    if (!corps) return;

    // 1. Les identifiants. On ne touche pas a un titre qui en a deja
    //    un, et on numerote les doublons plutot que de les ecraser.
    var titres = corps.querySelectorAll('h2');
    var pris = {};
    var parTexte = {};
    Array.prototype.forEach.call(titres, function (h) {
      if (!h.id) {
        var base = enIdentifiant(h.textContent || '') || 'section';
        var id = base;
        var n = 2;
        while (pris[id] || document.getElementById(id)) { id = base + '-' + n; n++; }
        h.id = id;
      }
      pris[h.id] = true;
      parTexte[reduire(h.textContent || '')] = h;
    });
    if (!titres.length) return;

    // 2. Le sommaire. On apparie chaque ligne a un titre : d'abord au
    //    mot pres, sinon par inclusion, sinon dans l'ordre d'apparition.
    var sommaire = document.querySelector('.lj-sommaire');
    if (!sommaire) return;
    var lignes = sommaire.querySelectorAll('li');
    var restants = Array.prototype.slice.call(titres);

    Array.prototype.forEach.call(lignes, function (li, i) {
      if (li.querySelector('a')) return; // deja un lien : on respecte
      var voulu = reduire(li.textContent || '');
      if (!voulu) return;

      var cible = parTexte[voulu];
      if (!cible) {
        for (var k = 0; k < restants.length; k++) {
          var t = reduire(restants[k].textContent || '');
          if (t.indexOf(voulu) === 0 || voulu.indexOf(t) === 0) { cible = restants[k]; break; }
        }
      }
      if (!cible && restants[i]) cible = restants[i];
      if (!cible) return;

      var a = document.createElement('a');
      a.href = '#' + cible.id;
      a.className = 'lj-sommaire__lien';
      while (li.firstChild) a.appendChild(li.firstChild);
      li.appendChild(a);
      a.addEventListener('click', function (ev) {
        ev.preventDefault();
        allerA(cible);
        if (history.replaceState) history.replaceState(null, '', '#' + cible.id);
      });
    });

    // 3. Une arrivee directe par adresse (#ma-section) doit elle aussi
    //    passer sous l'en-tete collant.
    if (window.location.hash) {
      var vise = document.getElementById(window.location.hash.slice(1));
      if (vise) window.setTimeout(function () { allerA(vise); }, 60);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', poser);
  } else {
    poser();
  }
  // L'editeur de theme recharge les sections sans recharger la page.
  document.addEventListener('shopify:section:load', poser);
})();
